import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/InventoryHealthTable.styles'

/**
 * Built on the row's OWN grid module, so replacing it with real data cannot
 * shift the layout (§7 — a skeleton that does not match the row it replaces
 * causes a jump).
 */
export default function InventoryHealthRowSkeleton() {
  const classes = useStyles()

  return (
    <div className={`${classes.row} ${classes.rowNormal}`} role="row">
      {Array(8)
        .fill('')
        .map((_, column) => (
          <div key={column} role="cell">
            <Skeleton variant="text" width="80%" />
          </div>
        ))}
    </div>
  )
}
